// extracted by mini-css-extract-plugin
module.exports = {"warningModal":"edit-title_warningModal_3BCRg","textarea":"edit-title_textarea_2CZRu"};